var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n  "+_vm._s(_vm.$t("pallet_structure_manual.auto_update"))+"\n  "),_c('input',{attrs:{"type":"checkbox","disabled":_vm.disableSwitch},domProps:{"checked":this.pallet.auto_update},on:{"input":_vm.switchMode}})])}
var staticRenderFns = []

export { render, staticRenderFns }